export default "__VITE_PUBLIC_ASSET__c65fdeb3__"